// Quote carousel. Every quotation here is documented (a book, published notes,
// or a mailing list post). Do not add quotes without a checkable source.
const en = {
  items: [
    {
      text: "Programming isn't about what you know; it's about what you can figure out.",
      name: "Chris Pine",
      role: "Author of 'Learn to Program'",
      image: "/img/quotes/idea_lamp.webp",
    },
    {
      text: "The only way to learn a new programming language is by writing programs in it.",
      name: "Brian Kernighan and Dennis Ritchie",
      role: "Authors of 'The C Programming Language'",
      image: "/img/quotes/software.webp",
    },
    {
      text: "Any fool can write code that a computer can understand. Good programmers write code that humans can understand.",
      name: "Martin Fowler",
      role: "Author of 'Refactoring'",
      image: "/img/quotes/checking.webp",
    },
    {
      text: "Talk is cheap. Show me the code.",
      name: "Linus Torvalds",
      role: "Creator of Linux",
      image: "/img/quotes/solving.webp",
    },
    {
      text: "Programs must be written for people to read, and only incidentally for machines to execute.",
      name: "Harold Abelson",
      role: "Co-author of 'Structure and Interpretation of Computer Programs'",
      image: "/img/quotes/books.webp",
    },
    {
      text: "The Analytical Engine weaves algebraical patterns just as the Jacquard loom weaves flowers and leaves.",
      name: "Ada Lovelace",
      role: "The world's first computer programmer",
      image: "/img/quotes/teaching.webp",
    },
    {
      text: "The function of good software is to make the complex appear to be simple.",
      name: "Grady Booch",
      role: "Co-creator of UML",
      image: "/img/quotes/tools.webp",
    },
    {
      text: "Simplicity is prerequisite for reliability.",
      name: "Edsger W. Dijkstra",
      role: "Turing Award winner",
      image: "/img/quotes/idea_lamp.webp",
    },
  ],
};

export default en;
